import VideoBackgroundFrontEnd from './VideoBackgroundFrontend';

export default VideoBackgroundFrontEnd;
